var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-header-card',{attrs:{"icon":_vm.analyte.icon(),"header":_vm.header,"rows":_vm.rows},scopedSlots:_vm._u([(_vm.sample_type)?{key:"SampleType",fn:function(){return [_c('a',{staticClass:"btn-link",attrs:{"href":`#/sampletypes/${_vm.sample_type.id}`}},[_vm._v("\n      "+_vm._s(_vm.sample_type.name)+"\n    ")])]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }